import React from 'react'

function MechanismItem ({item}) {
    return (
        <div className="inner lx-flex-row lx-text-color-white lx-hidden"  style={{ backgroundImage: `url(${item.img_url})` }}>
            <span className="title lx-fz17 lx-flex-row card-title">{ item.title }</span>
        </div>
    ) 
}

export default MechanismItem;